// frontend/src/components/PlatformUtils/PlatformUtils.jsx

import React from 'react';
import XIcon from '@mui/icons-material/X';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RedditIcon from '@mui/icons-material/Reddit';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ChatIcon from '@mui/icons-material/Chat';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import LanguageIcon from '@mui/icons-material/Language';
import BlockIcon from '@mui/icons-material/Block';
import PinterestIcon from '@mui/icons-material/Pinterest';
import VideocamIcon from '@mui/icons-material/Videocam';

export const PLATFORM_ICONS = {
    google: <GoogleIcon fontSize="small" />,
    meta: <FacebookIcon fontSize="small" />,
    facebook: <FacebookIcon fontSize="small" />,
    instagram: <InstagramIcon fontSize="small" />,
    tiktok: <MusicNoteIcon fontSize="small" />,
    twitter: <XIcon fontSize="small" />,
    x: <XIcon fontSize="small" />,
    youtube: <YouTubeIcon fontSize="small" />,
    linkedin: <LinkedInIcon fontSize="small" />,
    reddit: <RedditIcon fontSize="small" />,
    snapchat: <ChatIcon fontSize="small" />,
    telegram: <TelegramIcon fontSize="small" />,
    whatsapp: <WhatsAppIcon fontSize="small" />,
    pinterest: <PinterestIcon fontSize="small" />,
    twitch: <VideocamIcon fontSize="small" />,
    news_site: <NewspaperIcon fontSize="small" />,
    messaging_app: <ChatIcon fontSize="small" />,
    other: <LanguageIcon fontSize="small" />,
};

export const getPlatformDisplayName = (platform, t) => {
    if (!platform) return '';
    const key = platform.toLowerCase();
    
    // Normalize backend keys to their modern equivalents for translation mapping
    let transKey = key;
    if (key === 'facebook') transKey = 'meta';
    if (key === 'twitter') transKey = 'x';

    // Check if translation exists
    const translated = t(`contentInput.context.platforms.${transKey}`, { defaultValue: '' });
    
    if (translated && translated !== `contentInput.context.platforms.${transKey}`) {
        return translated;
    }

    // Fallback formatting
    return platform.charAt(0).toUpperCase() + platform.slice(1);
};

export const getPlatformOptions = (t) => {
    const platformKeys = [
        'google', 'instagram', 'linkedin', 'messaging_app', 'meta', 'news_site',
        'pinterest', 'reddit', 'snapchat', 'telegram', 'tiktok',
        'twitch', 'whatsapp', 'x', 'youtube'
    ];

    const platforms = platformKeys.map(key => ({
        value: key,
        label: getPlatformDisplayName(key, t),
        icon: PLATFORM_ICONS[key] || <LanguageIcon fontSize="small" />
    }));

    // 1. Sort Alphabetically
    platforms.sort((a, b) => a.label.localeCompare(b.label));

    // 2. Add "Other" at the end
    platforms.push({ 
        value: 'other', 
        label: getPlatformDisplayName('other', t), 
        icon: PLATFORM_ICONS['other'] 
    });

    // 3. Add "Select Platform" (Reset) at the start
    platforms.unshift({ 
        value: '', 
        label: t('contentInput.context.platformPlaceholder', { defaultValue: 'Select Platform' }), 
        icon: <BlockIcon fontSize="small" /> 
    });

    return platforms;
};